import React, { Fragment, useState } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import cx from "classnames";

import { useQuery } from "@apollo/client";
import { ABOUT_SERVICE } from "../../../queries";
import Content from "../Content";

import { TabContent, Card, Button } from "reactstrap";

import classnames from "classnames";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";

const StatusService = () => {
  const [activeTab, setActiveTab] = useState("0");
  const [active, setActive] = useState(true);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const { loading, error, data } = useQuery(ABOUT_SERVICE, {
    variables: { about_service_item_id: "QWJvdXRTZXJ2aWNlTm9kZTo2" },
  });

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );

  if (error) {
    return "...errrr";
  }

  const { aboutServiceItems } = data;

  const ServiceBtn = () => {
    return aboutServiceItems.edges.map((array, index) => (
      <Button
        key={index}
        style={{ background: "rgba(68, 202, 225, 1)" }}
        className={classnames("mb-1 dropdown-item")}
        onClick={(e) => {
          toggle(index.toString());
        }}
      >
        {array.node.title}
      </Button>
    ));
  };

  return (
    <Fragment>
      <CSSTransitionGroup
        className={cx("app-inner-layout chat-layout", {
          "open-mobile-menu": active,
        })}
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          <div className="app-inner-layout__wrapper row-fluid no-gutters service_sec">
            <Card className="app-inner-layout__sidebar bg-transparent">
              <div className="p-3">
                <div className="dropdown-menu p-0 dropdown-menu-inline dropdown-menu-rounded dropdown-menu-hover-primary">
                  {ServiceBtn()}
                </div>
              </div>
            </Card>
            <Card className="col-md-12 app-inner-layout__content">
              <div className="pb-5 pl-5 pr-5 pt-5">
                <div className="mobile-app-menu-btn mb-3"></div>
                <TabContent activeTab={activeTab}>
                  {aboutServiceItems.edges.map((node, index) => (
                    <Content index={index} data={node} id={node.node.id} />
                  ))}
                </TabContent>
              </div>
            </Card>
          </div>
        </div>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default StatusService;
